(() => {
  'use strict';

  const MESSAGES = [
    '☀️ En agosto enviamos pedidos los días 12 y 31',
    '🚚 Envío gratis desde 60 € (Península) | 80 € (Baleares)'
  ];

  const CHANGE_INTERVAL = 4500;

  const SELECTORS = [
    '.AnnouncementBar__Content',
    '.AnnouncementBar__Wrapper',
    '.AnnouncementBar p',
    '[data-section-type="announcement"] p',
    '#shopify-section-announcement p'
  ];

  let intervalId = null;

  function findAnnouncementElement() {
    for (const selector of SELECTORS) {
      const element = document.querySelector(selector);

      if (element) return element;
    }

    return null;
  }

  function initialiseMooaAnnouncement() {
    const element = findAnnouncementElement();

    if (!element || element.dataset.mooaAnnouncementReady === 'true') {
      return;
    }

    element.dataset.mooaAnnouncementReady = 'true';
    element.classList.add('MooaAnnouncement');

    element.innerHTML = `
      <span class="MooaAnnouncement__Message is-active">
        ${MESSAGES[0]}
      </span>
      <span class="MooaAnnouncement__Message">
        ${MESSAGES[1]}
      </span>
    `;

    const messages = Array.from(
      element.querySelectorAll('.MooaAnnouncement__Message')
    );

    if (messages.length < 2) return;

    let currentIndex = 0;

    if (intervalId) {
      window.clearInterval(intervalId);
    }

    intervalId = window.setInterval(() => {
      messages[currentIndex].classList.remove('is-active');
      currentIndex = (currentIndex + 1) % messages.length;
      messages[currentIndex].classList.add('is-active');
    }, CHANGE_INTERVAL);
  }

  function startMooaAnnouncement() {
    initialiseMooaAnnouncement();

    const observer = new MutationObserver(() => {
      initialiseMooaAnnouncement();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startMooaAnnouncement,
      { once: true }
    );
  } else {
    startMooaAnnouncement();
  }
})();